import React from 'react';
import PropTypes from 'prop-types';

import setupLegalPage from '../../util/legalPage';
import LegalPage from '../../components/legal-page/legal-page';
import Canonical from '../../util/canonical'

const CookiePolicy = ({ page, countryCode }) => {
  const countryCodePath = countryCode ? `/${countryCode}` : ''
  return (
    <>
      <Canonical path={`cookie-policy${countryCodePath}`}/>
      <LegalPage page={page} />
    </>
  )
};

export async function getServerSideProps(ctx) {
  return setupLegalPage('cookie', ctx);
}

CookiePolicy.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  page: PropTypes.any.isRequired,
  countryCode: PropTypes.string.isRequired
};

export default CookiePolicy;
